import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { SidebarTrigger } from "@/components/ui/sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuthStore } from "@/stores/auth-store";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { performLogout } from "@/lib/auth/logout";

const ROUTE_LABELS: Record<string, string> = {
  "/subscriptions": "구독 관리",
  "/articles": "아티클 관리",
  "/articles/new": "새 아티클",
};

function getRouteLabel(pathname: string): string {
  if (ROUTE_LABELS[pathname]) return ROUTE_LABELS[pathname];

  const matchedKey = Object.keys(ROUTE_LABELS)
    .sort((a, b) => b.length - a.length)
    .find((key) => pathname.startsWith(key));

  return matchedKey ? ROUTE_LABELS[matchedKey] : "대시보드";
}

export function AppHeader() {
  const adminUser = useAuthStore((s) => s.adminUser);
  const navigate = useNavigate();
  const location = useLocation();

  const currentLabel = getRouteLabel(location.pathname);

  const handleLogout = async () => {
    await performLogout();
    toast.success("로그아웃되었습니다");
    navigate("/login");
  };

  const initials =
    adminUser?.name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "AD";

  return (
    <header className="flex h-12 items-center justify-between border-b bg-background px-4">
      <div className="flex items-center gap-3">
        <SidebarTrigger className="-ml-1" />
        <div className="h-4 w-px bg-border/50" />
        <nav className="flex items-center gap-1.5 text-sm">
          <span className="text-muted-foreground">{currentLabel}</span>
        </nav>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-2">
            <Avatar className="h-6 w-6">
              <AvatarFallback className="bg-accent text-[10px] text-accent-foreground">
                {initials}
              </AvatarFallback>
            </Avatar>
            <span className="hidden text-sm md:inline">
              {adminUser?.name || "관리자"}
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel className="font-normal text-xs text-muted-foreground">
            {adminUser?.email || "admin@novela.so"}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="mr-2 h-4 w-4" />
            로그아웃
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
